var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiEnablement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 510,
    viewBox: "0 0 510 510",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.313 289.077L233.84 213.947L205.367 289.077M217.015 270.493H250.953M293.638 213.947V289.077M254.503 44.7383V84.1557",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.044 30.7634C274.828 21.6275 270.489 11.1536 261.354 7.36937C252.218 3.58515 241.744 7.92357 237.959 17.0595C234.175 26.1954 238.514 36.6693 247.65 40.4535C256.786 44.2377 267.259 39.8993 271.044 30.7634Z",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M394.361 53.5837C398.145 44.4478 393.806 33.9739 384.67 30.1897C375.534 26.4055 365.061 30.7439 361.276 39.8798C357.492 49.0157 361.831 59.4896 370.967 63.2738C380.102 67.058 390.576 62.7196 394.361 53.5837Z",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M357.651 46.7383H324.696C317.769 46.7383 312.154 52.3533 312.154 59.2803V100.488",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.036 63.2791C147.172 59.4948 151.51 49.021 147.726 39.885C143.942 30.7491 133.468 26.4107 124.332 30.1949C115.196 33.9792 110.858 44.453 114.642 53.5889C118.426 62.7249 128.9 67.0633 138.036 63.2791Z",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.354 46.7383H184.309C191.236 46.7383 196.851 52.3533 196.851 59.2804V100.489M254.503 464.285V424.868",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M261.362 501.642C270.498 497.858 274.836 487.384 271.052 478.248C267.268 469.112 256.794 464.774 247.658 468.558C238.522 472.342 234.183 482.816 237.968 491.952C241.752 501.088 252.226 505.427 261.362 501.642Z",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M384.679 478.818C393.815 475.034 398.153 464.56 394.369 455.424C390.585 446.288 380.111 441.95 370.975 445.734C361.839 449.518 357.5 459.992 361.285 469.128C365.069 478.264 375.543 482.602 384.679 478.818Z",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M357.651 462.285H324.696C317.769 462.285 312.154 456.67 312.154 449.743V408.535",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M147.734 469.131C151.518 459.995 147.18 449.521 138.044 445.737C128.908 441.952 118.434 446.291 114.65 455.427C110.866 464.563 115.204 475.036 124.34 478.821C133.476 482.605 143.95 478.267 147.734 469.131Z",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M151.354 462.285H184.309C191.236 462.285 196.851 456.67 196.851 449.743V408.534M44.729 254.512H84.1464",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4533 261.361C44.2375 252.225 39.8991 241.751 30.7632 237.967C21.6272 234.183 11.1534 238.521 7.36916 247.657C3.58493 256.793 7.92334 267.267 17.0593 271.051C26.1952 274.835 36.6691 270.497 40.4533 261.361Z",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2736 138.045C67.0578 128.909 62.7194 118.435 53.5835 114.651C44.4475 110.866 33.9737 115.205 30.1895 124.341C26.4052 133.477 30.7436 143.951 39.8796 147.735C49.0155 151.519 59.4894 147.181 63.2736 138.045Z",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.729 151.363V184.318C46.729 191.245 52.344 196.86 59.271 196.86H100.479",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5869 394.369C62.7228 390.585 67.0612 380.111 63.277 370.975C59.4928 361.839 49.0189 357.501 39.883 361.285C30.7471 365.069 26.4087 375.543 30.1929 384.679C33.9771 393.815 44.451 398.153 53.5869 394.369Z",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.729 357.66V324.704C46.729 317.777 52.3441 312.162 59.2711 312.162H100.48M464.276 254.512H424.859",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M491.951 271.045C501.087 267.26 505.425 256.787 501.641 247.651C497.857 238.515 487.383 234.176 478.247 237.961C469.111 241.745 464.772 252.219 468.557 261.355C472.341 270.49 482.815 274.829 491.951 271.045Z",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M469.128 147.728C478.264 143.944 482.602 133.47 478.818 124.334C475.034 115.198 464.56 110.86 455.424 114.644C446.288 118.428 441.949 128.902 445.734 138.038C449.518 147.174 459.992 151.513 469.128 147.728Z",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M462.276 151.363V184.318C462.276 191.245 456.66 196.86 449.733 196.86H408.526",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M478.822 384.67C482.606 375.534 478.268 365.06 469.132 361.276C459.996 357.491 449.522 361.83 445.738 370.966C441.954 380.102 446.292 390.576 455.428 394.36C464.564 398.144 475.038 393.806 478.822 384.67Z",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M462.276 357.66V324.705C462.276 317.778 456.661 312.163 449.734 312.163H408.525M345.694 237.012V220.305C345.694 208.928 339.574 198.328 329.722 192.64L270.473 158.434C260.622 152.746 248.382 152.746 238.53 158.434L179.281 192.64C169.429 198.328 163.309 208.928 163.309 220.305V288.718C163.309 300.094 169.429 310.695 179.281 316.383L238.53 350.589C248.382 356.277 260.622 356.277 270.472 350.589L329.721 316.383C339.573 310.695 345.693 300.094 345.693 288.718V272.011",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M301.732 136.068L287.974 128.124C267.328 116.203 241.677 116.203 221.03 128.124L161.781 162.331C141.135 174.252 128.31 196.466 128.31 220.306V288.72C128.31 312.56 141.136 334.774 161.782 346.696L221.03 380.902C241.677 392.823 267.328 392.823 287.973 380.902L347.223 346.696C367.869 334.774 380.694 312.56 380.694 288.72V220.306C380.694 196.466 367.869 174.252 347.222 162.331L332.043 153.568",
    stroke: "black",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiEnablement);
export default __webpack_public_path__ + "static/media/AiEnablement.160f887662c4d797b2da482c5666a276.svg";
export { ForwardRef as ReactComponent };